import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors } from 'app/variables';
import Button from 'app/commonComponents/Button';

import { useAppContext } from '../hooks';

const StyledButton = styled(Button)`
  display: block;
  margin-bottom: 1rem;
  width: 100%;

  img {
    float: left;
    height: 1em;
  }
`;

export default function SocialAuthButton({
  label,
  logo,
  logoStyle,
  targetUrl,
  ...rest
}) {
  const { config } = useAppContext();
  return (
    <StyledButton
      hollow
      color={colors.silver}
      type="button"
      onClick={() => {
        window.location.href = targetUrl;
      }}
      {...rest}
    >
      <img src={`${config.static_url}${logo}`} style={logoStyle} />
      {label}
    </StyledButton>
  );
}

SocialAuthButton.propTypes = {
  label: PropTypes.string,
  logo: PropTypes.string,
  logoStyle: PropTypes.object,
  targetUrl: PropTypes.string,
};

export function AppleButton(props) {
  return (
    <SocialAuthButton
      label={i18n.gettext('Apple')}
      logo="images/apple-logo.png"
      //logoStyle={{ height: '2em', margin: '-0.5em' }}
      {...props}
    />
  );
}

export function GoogleButton(props) {
  return (
    <SocialAuthButton
      label={i18n.gettext('Google')}
      logo="images/google-logo.png"
      {...props}
    />
  );
}
